import { aiStackData } from "@/mocks/aiSolutionsData";
import AnimatedSection from "@/components/AnimatedSection";

export default function AiStackSection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="container-astro">
        <AnimatedSection>
          <div className="text-center max-w-2xl mx-auto mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-extrabold text-foreground-950 mb-3 font-heading tracking-tight">
              {aiStackData.heading}
            </h2>
            <div className="w-16 h-1 rounded-full mx-auto bg-gradient-to-r from-[#2563EB] via-[#7C3AED] to-[#F97316]" />
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              {aiStackData.subtext}
            </p>
          </div>
        </AnimatedSection>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">
          {aiStackData.groups.map((group, i) => (
            <AnimatedSection key={group.name} delay={i * 80}>
              <div className="rounded-2xl border border-background-200/80 bg-background-100 p-6 md:p-7 card-lift hover:border-background-300/80">
                <div className="flex items-center gap-3 mb-5">
                  <div className="w-10 h-10 rounded-lg bg-secondary-100 text-secondary-700 flex items-center justify-center">
                    <span className="w-4 h-4 flex items-center justify-center">
                      <i className={`${group.icon} text-lg`} />
                    </span>
                  </div>
                  <h3 className="text-base font-bold text-foreground-950 font-heading">
                    {group.name}
                  </h3>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  {group.items.map((item) => (
                    <div
                      key={item.name}
                      className="flex items-center gap-2.5 rounded-xl border border-background-200/80 bg-background-50 px-3 py-2.5 transition-colors hover:border-accent-200"
                    >
                      <img
                        src={item.logo}
                        alt={item.name}
                        className="w-6 h-6 object-contain shrink-0"
                        loading="lazy"
                      />
                      <span className="text-xs font-medium text-foreground-700">
                        {item.name}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            </AnimatedSection>
          ))}
        </div>
      </div>
    </section>
  );
}